import { SyntheticEvent, useCallback, useState } from 'react';

export function useTab<T = number>(initialTab: T) {
  const [value, setValue] = useState<T>(initialTab);
  const onChange = useCallback((event: SyntheticEvent, newValue: T) => {
    setValue(newValue);
  }, []);

  return { value, onChange, setValue };
}

export type UseTabType<T> = ReturnType<typeof useTab<T>>;
